module.exports = __webpack_public_path__ + "static/media/oxford.0410b410.png";